import React from "react";
import "./AccessKeySection.scss";

const AccessKeySection = ({ image, title, description }) => {
  return (
    <div className="access-section">
      <div className="image-side">
        <img src={image} alt={title} />
      </div>

      <div className="content-side">
        <h2 className="title3">{title}</h2>

        <div className="text-side">
          <p
            className="description"
            dangerouslySetInnerHTML={{ __html: description }}
          ></p>
        </div>
      </div>

      <div className="dots-wrapper">
        <div className="dots-pattern4"></div>
      </div>
    </div>
  );
};

export default AccessKeySection;
